import Page from '@admin/components/page'
import Overview from './overview'
import React from 'react'
import Sent from './sent'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.email_campaign.title,
  manager: {
    path: `/admin/truevail/admin/deliverability/email_campaign/${resources.email_campaign.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Sent)',
        path: '/sent',
        panel: <Sent email_campaign={ resources.email_campaign } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  email_campaign: `/api/admin/truevail/admin/deliverability/email_campaigns/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
